module.exports={Remove:"Удалить"};